export default __webpack_public_path__ + "static/media/ems.db0aa08f.png";